export const UNSAVED_CHANGES_TEXT = 'You have unsaved changes. Do you want to leave?'

export default class UnsavedChangesChecker {
    haveUnsavedChanges() {
        // Always true for now, but in the future it would be the only place to modify
        return true;
    }
}